"use client";

import Link from "next/link";

import {
  NAV_ARRIVE,
  NAV_INK_FOCUS_RING,
  NAV_RAIL_WIDTH,
  arriveStep,
} from "@/components/nav/nav-styles";
import WorkspaceSwitcher, {
  WorkspaceLogo,
} from "@/components/nav/WorkspaceSwitcher";
import { cn } from "@/lib/utils";

const HOME_LINK = cn(
  "flex items-center rounded-lg px-1.5 py-1 transition-colors hover:bg-white/5",
  NAV_INK_FOCUS_RING,
);

/**
 * The studio's mark at the left of the navy top bar (NavTopBar). Normally the
 * full logo: for someone who can switch studios it is the switcher's trigger
 * (`WorkspaceSwitcher`), otherwise a link home; either way it is its own
 * name. While search or Sabine's chat has the column beside the rail
 * (`compact`), what drives it takes the bar beside the mark, so the mark
 * shrinks to fit over the rail, as a link home. When the column closes the
 * full mark comes back as an arrival (NAV_ARRIVE), after what was over the
 * column has faded, rather than appearing underneath it.
 */
export default function StudioBand({
  displayName,
  displayLogo,
  switcher,
  compact = false,
}) {
  const workspace = { name: displayName, image: displayLogo };
  if (compact) {
    return (
      <div key="compact" className={cn("flex shrink-0 justify-center", NAV_RAIL_WIDTH)}>
        <Link href="/" aria-label={displayName || "Home"} className={HOME_LINK}>
          <WorkspaceLogo workspace={workspace} compact ink />
        </Link>
      </div>
    );
  }
  return (
    // Keyed apart from the compact mark, so it mounts afresh and arrives.
    <div
      key="full"
      className={cn(NAV_ARRIVE, "flex min-w-0 shrink-0 items-center")}
      style={arriveStep(0)}
    >
      {switcher ? (
        <WorkspaceSwitcher {...switcher} />
      ) : (
        <Link href="/" className={HOME_LINK}>
          <WorkspaceLogo workspace={workspace} ink />
        </Link>
      )}
    </div>
  );
}
